<template>
    <div class="sidebar">
        <button @click="goBack()" class="backbutton">
            <img :src="imagePath(backbutton)">
        </button>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        backbutton: {
            type: String,
            default: 'backbutton',
        }
    },

    methods: {
        imagePath: function (fileName) {
            if(fileName != '')
                return require('../assets/icons/' + fileName + '.svg')
        },

        goBack: function() {
            this.$router.go(-1);
        }
    }
}
</script>

<style>
.sidebar {
    width: 403px;
    padding-bottom: 20px;
    position: absolute;
    top: 137px;
    left: 47px;
    background: #FDFDFD 0% 0% no-repeat padding-box;
    box-shadow: 25px 31px 53px #1516221A;
    border-radius: 23px;
}

.sidebar h3 {
    width: 212px;
    margin-left: 67px;
    margin-top: 44px;
    margin-bottom: 47px;
    text-align: left;
    font-family: CorpBold;
    font-size: 32px;
    line-height: 35px;
    letter-spacing: 1.76px;
    color: #000000;
    text-transform: uppercase;
    opacity: 1;
}

.sidebar ul {
  list-style: none;
}

.sidebar ul li {
    width: 344px;
    height: 123px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 25px 31px 53px #1516220D;
    border-radius: 14px;
    font-family: Demi;
    font-size: 20px;
    line-height: 32px;
    letter-spacing: 0.2px;
    color: #043171;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.sidebar .backbutton {
    cursor: pointer;
    position: absolute;
    background-color: transparent;
    border: none;
    top: 30px;
    left: -45px;
    width: 101px;
    height: 87px;
}

@media only screen and (max-device-width: 1366px) {
    .sidebar {
        width: 200px;
        padding-bottom: 5px;
    }

    .sidebar h3 {
        width: 120px;
        margin-left: 49px;
        margin-top: 48px;
        margin-bottom: 30px;
        font-size: 16px;
        line-height: 21px;
        letter-spacing: 1px;
    }

    .sidebar ul {
      list-style: none;
    }

    .sidebar ul li {
        width: 170px;
        height: 70px;
        font-size: 13px;
    }

    .sidebar .backbutton, .sidebar .backbutton img {
        width: 90px;
        height: 76px;
    }
}
</style>